// First, before Cinnamon: its compiled async code calls a global regeneratorRuntime
import "regenerator-runtime/runtime";
import { Buffer } from "buffer";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { setupApp } from "./setup";
import Shell from "./pages/Shell";

// content-disposition (modules/helpers/files.js) decodes RFC 5987 filename* values with Node's
// global Buffer, which webpack's ProvidePlugin supplied
globalThis.Buffer ??= Buffer;

const { store } = setupApp();

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  </Provider>
);

const root = createRoot(document.getElementById("root"));
root.render(<App />);
